import kiosk from './kiosk';
import kiosks from './kiosks';
import permits from "./permits";
import terminals from "./terminals";

export default {
  namespaced: true,
  modules: {
    kiosk,
    kiosks,
    permits,
    terminals
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/kiosks/index.js